/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Max_Steps_DecreaseInputs */



/**
* | output |
* | --- |
* | "Decrease the action limit" |
*
* @param {Agent_Builder_Max_Steps_DecreaseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_decrease = /** @type {((inputs?: Agent_Builder_Max_Steps_DecreaseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_DecreaseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktionslimit verringern")
	return /** @type {LocalizedString} */ ("Decrease the action limit")
});